/**
 * Truncates text items.
 *
 * @param items
 * @param maxLength
 */
export function truncateTextItems(items: string[], maxLength: number): string {
  let buf = ''
  let lastKnownStringThatFits = `${items.length} selected`
  for (const i in items) {
    const index = Number(i)
    const item = items[index]
    const itemsText = index === 0 ? item : `${buf}, ${item}`
    const itemsLeft = items.length - (index + 1)
    const andMore = itemsLeft === 0 ? '' : ` + ${itemsLeft} more`
    const itemsAndMore = itemsText + andMore
    if (itemsAndMore.length <= maxLength) {
      lastKnownStringThatFits = itemsAndMore
    }

    buf = itemsText

    if (buf.length > maxLength) {
      break
    }
  }

  return buf.length > maxLength ? lastKnownStringThatFits : buf
}

/**
 * Function that capitalizes the first letter of a string and makes the rest of the string lowercase.
 */
export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}
